import React from 'react'
import { Button } from 'antd'
import moment from 'moment'
import { STATUS_META, statusOf, allChecks, inr, fmtDate, alertStatusLabel, checkLabel } from './helpers'

const rowCls = (it) => {
  const s = statusOf(it)
  if (s === 'AUDITED') return 'st-audited'
  if (s === 'CHANGED') return 'st-changed'
  if (s === 'QUERY') return 'st-query'
  return allChecks(it).length ? 'st-flag' : ''
}

// Sum of line values. If any line has no value (blank line, unparseable rate)
// the total is incomplete, so it is shown with a marker rather than as a clean figure.
export const voucherValue = (it) => {
  let sum = 0; let missing = 0
  ;(it.lines || []).forEach(l => { if (typeof l.value === 'number') sum += l.value; else missing++ })
  return { sum, missing }
}

export const StatusPill = ({ item }) => {
  const s = statusOf(item)
  const m = STATUS_META[s]
  const bulk = s === 'AUDITED' && item.audit && item.audit.mode === 'BULK'
  const qa = s === 'QUERY' && item.audit && item.audit.queryAlert
  return <span className={'pill ' + m.cls} title={qa ? 'Audit Query ' + qa.alertNo : ''}>{m.label}{bulk ? ' · bulk' : ''}{qa && qa.status ? ' · ' + alertStatusLabel(qa.status) : ''}</span>
}

const QueueList = ({ items, count, curId, sel, canSelect, onPick, onToggleSel, hasMore, loadingMore, onLoadMore, sortLabel }) => (
  <div className='queue' aria-label='Vouchers'>
    <div className='qhead'>
      <span>{items.length} of {count} voucher{count === 1 ? '' : 's'}</span>
      <span>{Object.keys(sel).length ? Object.keys(sel).length + ' selected' : sortLabel}</span>
    </div>
    {!items.length && <div className='empty' style={{ margin: 14 }}>No vouchers match these filters.</div>}
    {items.map(it => {
      const ch = allChecks(it)
      const crit = ch.filter(c => c.severity === 'CRITICAL').length
      const warn = ch.filter(c => c.severity === 'WARNING').length
      const other = ch.length - crit - warn
      const who = it.voucherType === 'PI'
        ? ((it.vendor && it.vendor.name) || 'Vendor not set')
        : ((it.jobCard && it.jobCard.no) || 'Job card not set') + (it.jobCard && it.jobCard.asset ? ' · ' + it.jobCard.asset.assetCode : '')
      const spares = (it.lines || []).filter(l => l.spare).map(l => l.spare.name)
      const v = voucherValue(it)
      const eligible = canSelect(it)
      return (
        <div key={it.voucherId} className={'qi ' + rowCls(it) + (curId === it.voucherId ? ' cur' : '')} data-id={it.voucherId}
          onClick={() => onPick(it.voucherId)}>
          <input type='checkbox' checked={!!sel[it.voucherId]} disabled={!eligible}
            title={eligible ? 'Select for bulk audit' : 'Only new vouchers with no checks can be bulk audited'}
            aria-label={'Select ' + it.voucherNo}
            onClick={e => e.stopPropagation()} onChange={() => onToggleSel(it)} />
          <div style={{ minWidth: 0, display: 'grid', gap: 2 }}>
            <div className='l1'>
              <span className={'type ' + it.voucherType}>{it.voucherType}</span>
              <span className='no'>{it.voucherNo}</span>
              <StatusPill item={it} />
              {it.pendingInvoice && <span className='pill pendinv' title='Goods received on GRN; invoice to follow'>Invoice pending</span>}
            </div>
            <div className='l2'>{who}</div>
            <div className='l3'>
              <span>{fmtDate(it.date, moment) || 'No date'}{it.location ? ' · ' + it.location.name : ''}</span>
              <span>{(it.lines || []).length} line{(it.lines || []).length === 1 ? '' : 's'}</span>
              <span>{spares.slice(0, 2).join(', ')}{spares.length > 2 ? '…' : ''}</span>
            </div>
          </div>
          <div className='r'>
            <span className='amt' title={v.missing ? v.missing + ' line(s) have no value and are not in this total' : ''}>
              {inr(Math.round(v.sum))}{v.missing ? ' +?' : ''}
            </span>
            <span className='flags-mini' title={Array.from(new Set(ch.map(c => checkLabel(c.code)))).join('\n')}>
              {crit > 0 && <span className='fm crit' title='Critical checks'>{crit}</span>}
              {warn > 0 && <span className='fm warn' title='Warnings'>{warn}</span>}
              {other > 0 && <span className='fm neutral' title='Other checks'>{other}</span>}
              {!ch.length && <span className='okmark'>✓ clean</span>}
            </span>
          </div>
        </div>
      )
    })}
    {hasMore && (
      <div className='more'>
        <Button size='small' loading={loadingMore} onClick={onLoadMore}>Load {Math.min(50, count - items.length)} more</Button>
      </div>
    )}
  </div>
)

export default QueueList
